<div style="min-height: 100%; position: relative;">
<router-outlet></router-outlet>
</div>
